import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoDiluyente/editTipoDiluyente`, method: 'POST', body: values, token: token})
}
